/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum Opacities {
  LightBorder = 0.1,
  Disabled = 0.3,
  DisabledIcon = 0.1,
  DisabledCustomIcon = 0.4,
  Light = 0.4,
  Overlay = 0.8,
}
